export default __webpack_public_path__ + "static/media/quickspin.2f01d0ca.png";